import { useAuthStore } from '@/feature/auth/store/auth'
import type { AssetTag } from '@/feature/tags'

import { useNetworkRequest } from '@/lib/utils/request'

export interface AlertRecord {
  id: string
  enabled: boolean
  title: string
  organization: number
  emails: string[]
  phoneNumbers: string[]
  templateName: string
  templateVariables: Record<string, number>
  /** Vehicle tags this alert is scoped to. Empty or absent means the alert is global. */
  tags?: AssetTag[] | null
  createdAt: string
  updatedAt: string
}

export const alertHasContacts = (alert: AlertRecord): boolean =>
  alert.emails.length > 0 || alert.phoneNumbers.length > 0

export const useAllAlerts = (): ReturnType<typeof useNetworkRequest<AlertRecord[]>> => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  return useNetworkRequest<AlertRecord[]>(isAuthenticated ? { url: 'v1/alerts/' } : null)
}
